
















import { Component, Vue, Prop } from 'vue-property-decorator'
import IClose from '@/components/icons/IClose.vue'

@Component({
  name: 'alert',
  components: {
    IClose,
  }
})
export default class Alert extends Vue {
  @Prop({type: String, default: ''}) text !:any
  @Prop({type: String, default: ''}) btn !:any
  @Prop({type: Boolean, default: false}) isClose !:any

}
